import { useState } from "react";
import { api } from "@/App";
import { Loader2, Lock, Mail } from "lucide-react";
import { saveEmail } from "@/components/TrialGate";

const KEY = "kk_fc_unlocked";
const field = "flex-1 min-w-0 bg-[#0e1013] border border-[#2a2f3d] px-3 py-2.5 text-sm text-white focus:border-white outline-none transition-colors";

export const useFreeUnlock = () => {
  const [email, setEmail] = useState(() => localStorage.getItem(KEY));
  const unlock = (e) => { localStorage.setItem(KEY, e); saveEmail(e); setEmail(e); };
  return [email, unlock];
};

export const FreeUnlockForm = ({ color, onUnlock }) => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await api.post("/free/unlock", { email, consent }); onUnlock(email); }
    catch (x) { setErr(x?.response?.status === 422 ? "Please enter a valid email address." : x?.response?.data?.detail || "Something went wrong, please try again."); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="border p-5 space-y-3" style={{ borderColor: color }} data-testid="film-compression-unlock-form">
      <div className="flex items-center gap-2 font-display uppercase text-lg"><Lock size={16} style={{ color }} /> Get your free download</div>
      <p className="text-sm text-[#9ba3b4]">Enter your email to unlock the downloads. We also send you the links so you can install it on your other machines.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input className={field} type="email" required maxLength={200} placeholder="you@studio.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="film-compression-email-input" />
        <button disabled={busy} className="px-5 py-2.5 text-sm font-semibold text-black flex items-center justify-center gap-2 transition-opacity hover:opacity-85 disabled:opacity-60" style={{ background: color }} data-testid="film-compression-unlock-btn">
          {busy ? <Loader2 size={14} className="spin" /> : <Mail size={14} />} Unlock downloads
        </button>
      </div>
      <label className="flex items-center justify-start gap-2 text-xs text-[#9ba3b4] cursor-pointer w-fit">
        <input type="checkbox" className="w-4 h-4 flex-none accent-[#f2c46d]" style={{ width: 16 }} checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="film-compression-consent-checkbox" />
        <span>Send me KolorKlinic news & offers (optional, unsubscribe any time)</span>
      </label>
      {err && <div className="text-xs text-[#ff453a]" data-testid="film-compression-unlock-error">{err}</div>}
    </form>
  );
};
